var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable react/display-name */
import * as React from "react";
import { joinClasses } from "../utils/Filters";
/**
 *
 * @param pl
 */
export var createPalleteClassName = function (pl) {
    // Color classes
    if (!pl) {
        return undefined;
    }
    return "scl-h-color--".concat(pl);
};
/**
 *
 * @param pl
 */
export var createPalleteShadeClassName = function (pl) {
    // Color classes
    if (!pl) {
        return undefined;
    }
    return "scl-h-shade--".concat(pl);
};
/**
 *
 * @param pl
 */
export var createPalleteStateClassName = function (pl) {
    if (!pl) {
        return undefined;
    }
    // State classes
    return "scl-h-state--".concat(pl);
};
/**
 *
 * @param prefix
 * @param spacing
 */
export var createSpacingClassName = function (prefix, spacing) {
    if (!spacing) {
        return undefined;
    }
    if (typeof spacing === "number") {
        return "scl-h-spacing-".concat(prefix, "-").concat(spacing);
    }
    return Object
        .keys(spacing)
        .reduce(function (value, bp) { return (Object
        .keys(spacing[bp])
        .reduce(function (v, pos) {
        var _a;
        var bpKey = bp;
        // spacing[bp][pos]
        var spacingBp = spacing[bpKey];
        var posKey = pos;
        var posValue = (_a = spacingBp === null || spacingBp === void 0 ? void 0 : spacingBp[posKey]) !== null && _a !== void 0 ? _a : "";
        return joinClasses(v, "scl-h-spacing-".concat(prefix).concat(pos, "-").concat(bp).concat(posValue));
    }, value)); }, "");
};
/**
 *
 * @param an
 */
var createAnimationClassName = function (an) {
    if (!an) {
        return undefined;
    }
    // Animation classes
    return "scl-h-animation--".concat(an);
};
/**
 *
 * @param sh
 */
var createShadowClassName = function (sh) {
    if (!sh) {
        return undefined;
    }
    // Shadow classes
    return "scl-h-shadow--".concat(sh);
};
/**
 *
 * @param param
 */
export var mapThemePropsToClassNames = function (_a) {
    var margin = _a.margin, padding = _a.padding, palette = _a.palette, paletteShade = _a.paletteShade, paletteState = _a.paletteState, animation = _a.animation, shadow = _a.shadow;
    return (joinClasses(createSpacingClassName("m", margin), createSpacingClassName("p", padding), createPalleteClassName(palette), createPalleteShadeClassName(paletteShade), createPalleteStateClassName(paletteState), createAnimationClassName(animation), createShadowClassName(shadow)));
};
/**
 *
 * @param Clazz
 * @param mttc mapStateToClassname mapping function for a component's specific
 * theme properties.
 */
export var asThemeConsumer = function (Clazz, mttc) { return function (props) {
    var theme = props.theme || {};
    var className = props.className;
    var themeClassName = mapThemePropsToClassNames(theme);
    var specificClassName = !!mttc ? mttc(theme) : undefined;
    var processed = __assign(__assign({}, props), { className: joinClasses(className, themeClassName, specificClassName) });
    return (React.createElement(Clazz, __assign({}, processed)));
}; };
